import styled from 'styled-components';

export const InitialVerificationsContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 24px;
  background-color: #ffffff;
  gap: 26px;
`;

export const SearchLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.65);
`;

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeaderTop = styled.div`
  display: flex;
  align-items: center;
`;

export const ApoliceAtivaLabel = styled.span`
  font-size: 14px;
  color: #666;
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  
  .icon {
    color: ${props => props.theme.main.color};
  }
`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const IntroText = styled.div`
  p {
    font-size: 14px;
    color: #666;
    line-height: 1.6;
    margin: 0;
  }
`;

export const BoldText = styled.span`
  font-weight: 600;
  color: #333;
`;

export const RedText = styled.span`
  color: #FF3B30;
  font-weight: 600;

`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SectionWithBorder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  gap: 24px;
  border: 1px solid #C8ACFD;
  border-radius: 8px;
  background-color: #ffffff;
`;

export const OccupationSectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: #222;
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const LabelWithIcon = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #393939;
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 19px;
  
  .icon {
    width: 16px;
    height: 16px;
    color: ${props => props.theme.main.color};
    cursor: pointer;
  }
`;

export const Required = styled.span`
  color: #e74c3c;
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 24px;
  max-width: 300px;
  
  .ui.radio.checkbox {
    label {
      font-size: 14px;
      color: #333;
      cursor: pointer;
      position: relative;
      padding-left: 1.85714em !important;
    }
    
    /* Estilo padrão - borda cinza, sem preenchimento */
    label:before {
      border-color: #ccc !important;
      background-color: transparent !important;
      border-width: 1px !important;
      width: 15px !important;
      height: 15px !important;
    }
    
    /* Quando selecionado - mantém borda cinza */
    input[type="radio"]:checked ~ label:before {
      border-color: #ccc !important;
      background-color: transparent !important;
    }
    
    /* Círculo interno roxo quando selecionado - sobrescrevendo o :after do Semantic UI */
    input[type="radio"]:checked ~ label:after {
      content: '' !important;
      position: absolute !important;
      width: 15px !important;
      height: 15px !important;
      border-radius: 500rem !important;
      background-color: ${props => props.theme.main.color} !important;
      top: 1px !important;
      left: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      opacity: 1 !important;
      transform: scale(0.46666667) !important;
    }
  }
`;

export const TenantTypeRow = styled.div`
  display: flex;
  gap: 60px;
  align-items: flex-start;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const TenantTypeColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 120px;
  max-width: 300px;
  
  .ui.input {
    width: 100%;
    
    input {
      font-size: 14px;
    }
  }
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
`;

export const SectionDescription = styled.p`
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
`;

export const TableWrapper = styled.div`
  margin-top: 16px;
  
  .ui.table {
    font-size: 14px;
    
    thead th {
      background-color: #f8f9fa;
      font-weight: 600;
      color: #333;
    }
    
    tbody td {
      color: #666;
    }
    
    .ui.radio.checkbox {
      margin: 0;
      
      label {
        font-size: 14px;
        color: #333;
        cursor: pointer;
        position: relative;
        padding-left: 1.85714em !important;
      }
      
      /* Estilo padrão - borda cinza, sem preenchimento */
      label:before {
        border-color: #ccc !important;
        background-color: transparent !important;
        border-width: 1px !important;
        width: 15px !important;
        height: 15px !important;
      }
      
      /* Quando selecionado - mantém borda cinza */
      input[type="radio"]:checked ~ label:before {
        border-color: #ccc !important;
        background-color: transparent !important;
      }
      
      /* Círculo interno roxo quando selecionado - sobrescrevendo o :after do Semantic UI */
      input[type="radio"]:checked ~ label:after {
        content: '' !important;
        position: absolute !important;
        width: 15px !important;
        height: 15px !important;
        border-radius: 500rem !important;
        background-color: ${props => props.theme.main.color} !important;
        top: 1px !important;
        left: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
        border: none !important;
        opacity: 1 !important;
        transform: scale(0.46666667) !important;
      }
    }
  }
`;

export const ExistingClaimCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: #ffffff;
  margin-top: 16px;
  gap: 20px;
`;

export const ClaimDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex: 1;
`;

export const ClaimDetailsRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  flex-wrap: wrap;
`;

export const ClaimDetailItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 120px;
`;

export const ClaimLabel = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;
`;

export const ClaimValue = styled.span`
  font-size: 14px;
  color: #666;
  font-weight: 400;
`;

export const ArrowButton = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;
  padding: 0 16px;
  border-radius: 8px;
  background-color: ${props => props.theme.main.color};
  color: #ffffff;
  transition: opacity 0.2s;
  flex-shrink: 0;
  
  &:hover {
    opacity: 0.9;
  }
  
  .icon {
    margin: 0 !important;
    color: #ffffff;
  }
`;

export const OccupationButtons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 16px;
  padding: 0px;
`;

export const OccupationButton = styled.div<{ selected?: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 4px 12px;
  gap: 8px;
  width: 218px;
  height: 40px;
  border: 1px solid ${props => props.theme.main.color};
  border-radius: 4px;
  background-color: ${props => props.selected ? props.theme.main.color : '#ffffff'};
  color: ${props => props.selected ? '#ffffff' : props.theme.main.color};
  cursor: pointer;
  transition: all 0.2s;
  
  &:hover {
    opacity: ${props => props.selected ? 1 : 0.8};
  }
  
  .icon {
    margin: 0 !important;
    width: 16px;
    height: 16px;
    color: ${props => props.selected ? '#ffffff' : props.theme.main.color};
  }
  
  span {
    font-size: 14px;
    font-weight: 600;
    line-height: 19px;
  }
`;

export const DocumentsInfoSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const DocumentsDescription = styled.p`
  font-size: 12px;
  line-height: 16px;
  color: #393939;
  margin: 0;
  font-weight: 400;
`;

export const DocumentsListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 12px;
  gap: 12px;
  width: 100%;
  background: #F8F4FF;
  border: 1px solid #C8ACFD;
  border-radius: 8px;
  margin-top: 8px;
  min-height: fit-content;
`;

export const DocumentsListTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #393939;
  margin: 0;
`;

export const DocumentsList = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #2B313C;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const DocumentItem = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #2B313C;
  margin: 0;
  padding: 0;
`;

export const DocumentsListAdditional = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #2B313C;
  margin: 0;
  padding: 0;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const BudgetsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px;
  gap: 12px;
  width: 100%;
  margin-top: 12px;
`;

export const BudgetCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px;
  gap: 12px;
  flex: 1;
  background: #FFFFFF;
  border: 2px solid #854EE0;
  border-radius: 8px;
  box-sizing: border-box;
`;

export const BudgetCardTitle = styled.h3`
  font-size: 14px;
  font-weight: 700;
  line-height: 19px;
  color: #59249B;
  margin: 0;
  padding: 0;
  width: 100%;
`;

export const BudgetCardContent = styled.div`
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  color: #2B313C;
  margin: 0;
  padding: 0;
  width: 100%;
  
  strong {
    font-weight: 700;
  }
`;

export const DocumentationLabel = styled.label`
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  color: #393939;
  display: flex;
  align-items: center;
  gap: 2px;
`;

export const DocumentationRadioGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  gap: 32px;
  border-radius: 4px;
  margin-top: 4px;
  
  .ui.radio.checkbox {
    label {
      font-size: 12px;
      line-height: 16px;
      color: #2B313C;
      font-weight: 400;
      padding-left: 1.85714em !important;
    }
    
    label:before {
      width: 22.65px !important;
      height: 22.65px !important;
      border: 2px solid #6B7280 !important;
      background-color: #FFFFFF !important;
    }
    
    input[type="radio"]:checked ~ label:before {
      border-color: #6B7280 !important;
      background-color: #FFFFFF !important;
    }
    
    input[type="radio"]:checked ~ label:after {
      content: '' !important;
      position: absolute !important;
      width: 22.65px !important;
      height: 22.65px !important;
      border-radius: 500rem !important;
      background-color: ${props => props.theme.main.color} !important;
      top: 0 !important;
      left: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      border: none !important;
      opacity: 1 !important;
      transform: scale(0.46666667) !important;
    }
  }
`;

export const InfoBanner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 4px 8px;
  gap: 10px;
  width: 100%;
  height: 40px;
  background: #FFF1D2;
  border-radius: 4px;
  margin-top: 8px;
  box-sizing: border-box;
  
  font-size: 12px;
  line-height: 16px;
  color: #000000;
  font-weight: 400;
  flex: none;

  margin-top: -12px;
  
  strong {
    font-weight: 400;
  }
`;

export const FooterButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 0;
  padding-top: 24px;
  border-top: 1px solid #e0e0e0;
`;